<p-calendar
    [(ngModel)]="date"
    [showClear]="true"
    [inputStyleClass]="'rounded-lg date-input'"
    [dateFormat]="dateFormat"
    (ngModelChange)="onChange($event)"
></p-calendar>
